import React from 'react';
import { Download, Share2, Smartphone, X } from 'lucide-react';
import { useLocalization } from '../context/LocalizationContext';

export const PwaInstallBanner = ({
  mode = 'install',
  onInstall,
  onDismiss,
}) => {
  const { t } = useLocalization();

  const isIosMode = mode === 'ios';

  return (
    <div className="app-highlight-surface px-4 py-4">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-3 min-w-0">
              <div className="app-icon-chip mt-0.5 shrink-0 bg-primary-500 text-white shadow-sm">
            {isIosMode ? <Share2 size={20} /> : <Download size={20} />}
          </div>
          <div className="min-w-0">
            <h2 className="app-panel-title text-xl">
              {isIosMode ? t('pwa.iosTitle') : t('pwa.bannerTitle')}
            </h2>
            <p className="mt-1 text-sm text-primary-800 dark:text-primary-200">
              {isIosMode ? t('pwa.iosSubtitle') : t('pwa.bannerSubtitle')}
            </p>
            {isIosMode && (
              <div className="app-note mt-3 flex items-center gap-2 border-primary-100 dark:border-slate-700 dark:bg-slate-800/70">
                <Smartphone size={16} className="text-primary-500" />
                <span>{t('pwa.iosSteps')}</span>
              </div>
            )}
            {!isIosMode && (
              <div className="mt-4 flex flex-wrap items-center gap-2">
                <button
                  type="button"
                  onClick={onInstall}
                  className="app-primary-button rounded-full px-4 py-2"
                  data-testid="pwa-install-banner-button"
                >
                  {t('pwa.installNow')}
                </button>
                <button
                  type="button"
                  onClick={onDismiss}
                  className="app-secondary-button rounded-full px-4 py-2"
                >
                  {t('pwa.notNow')}
                </button>
              </div>
            )}
          </div>
        </div>
        <button
          type="button"
          onClick={onDismiss}
          className="rounded-full p-2 text-slate-500 transition-colors hover:bg-white/80 hover:text-slate-700 dark:hover:bg-slate-800 dark:hover:text-slate-200"
          aria-label={t('pwa.dismiss')}
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default PwaInstallBanner;
